import get from 'lodash/get';
import * as micYearPageActions from '../../action_creators/mic/mic_year_page_action_creators';
import log from '../../../services/logger_service';
import micYearActions from './async_mic_year_actions';
import micYearDescriptionActions from './async_mic_year_description_actions';
import micSectorActions from './async_mic_sector_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import axios from 'axios';
import https from 'https';

function getExternalList(params) {
  const { year } = params;
  const httpsAgent = new https.Agent({
    rejectUnauthorized: false
  });
  if (year === '2022') {
    return [
      axios.get(`https://airtablemgr.mansueto.com/franchise/mic-2022`, {
        httpsAgent
      })
    ];
  }

  if (year === '2023') {
    return [
      axios.get(`https://airtablemgr.mansueto.com/franchise/mic-2023`, {
        httpsAgent
      })
    ];
  }

  if (year === '2024') {
    return [
      axios.get(`https://airtablemgr.mansueto.com/franchise/mic-2024`, {
        httpsAgent
      })
    ];
  }

  if (year === '2025') {
    return [
      axios.get(`https://airtablemgr.mansueto.com/franchise/mic-2025`, {
        httpsAgent
      })
    ];
  }

  if (year === 'list') {
    return [
      axios.get(`https://airtablemgr.mansueto.com/franchise/mic-2026`, {
        httpsAgent
      })
    ];
  }

  return [new Promise(resolve => resolve(true))];
}

export default function fetchMicPage(params, store) {
  return function firstDispatch(dispatch) {
    const { year } = params;

    if (parseInt(year, 10) >= 2020 || year === 'list') {
      return Promise.all([
        micYearActions(params, store)(dispatch),
        ...getExternalList(params, store)
      ])
        .then(function handlePostDetailData(data) {
          const externalData = get(data, '[1].data.data', null);

          const pageData = {};
          if (year === 'list') {
            // Handle 2026
            pageData.winners = [];
            pageData.sectors = [];
            pageData.carousels = [];
            pageData.metadata = get(externalData, 'pageMeta', null);
            pageData.metadata = [
              {
                'SEO title': get(pageData.metadata, 'seo_title', ''),
                'SEO description': get(
                  pageData.metadata,
                  'seo_description',
                  ''
                ),
                PageTitle: get(pageData.metadata, 'seo_title', ''),
                Subhead: get(pageData.metadata, 'subhead', ''),
                Blurb: get(pageData.metadata, 'blurb', ''),
                socialshareimage: get(pageData.metadata, 'social_headline', ''),
                shareText: get(pageData.metadata, 'social_share_text', ''),
                splashPageImage:
                  'https://assets.fastcompany.com/image/upload/v1710254059/mic_logo_1034.svg',
                splashPageText:
                  'The Most Innovative Companies list will be available on Tuesday, March 24, at 7 a.m. ET.',
                pastYearsTitle: 'SEE LAST YEAR’S LIST',
                registerLink:
                  'https://www.fastcompany.com/apply/most-innovative-companies',
                registerTitle: 'Apply to the 2027 list',
                ...pageData.metadata[0]
              }
            ];
            pageData.socialPlanning = [];
            pageData.carouselItems = [];
            pageData.supplements = [];
            pageData.dropdown = [];
            pageData.year = '2026';

            dispatch(micYearPageActions.micYearPageLoaded(pageData, store));
            return true;
          }
          if (year === '2025') {
            // Handle 2025
            pageData.winners = get(externalData, 'Winners', null);
            pageData.sectors = get(externalData, 'Sectors', null);
            pageData.carousels = get(externalData, 'Carousels', null);
            pageData.metadata = get(externalData, 'Metadata', null);
            pageData.socialPlanning = get(
              externalData,
              'Social planning',
              null
            );
            pageData.carouselItems = get(externalData, 'Carousel Items', null);
            pageData.supplements = get(externalData, 'Supplements', null);
            pageData.dropdown = get(externalData, 'Dropdown', null);
            pageData.year = '2025';

            dispatch(micYearPageActions.micYearPageLoaded(pageData, store));
            return true;
          }
          if (year === '2024') {
            // Handle 2024
            pageData.winners = get(externalData, 'Winners', null);
            pageData.sectors = get(externalData, 'Sectors', null);
            pageData.carousels = get(externalData, 'Carousels', null);
            pageData.metadata = get(externalData, 'Metadata', null);
            pageData.socialPlanning = get(
              externalData,
              'Social planning',
              null
            );
            pageData.carouselItems = get(externalData, 'Carousel Items', null);
            pageData.supplements = get(externalData, 'Supplements', null);
            pageData.dropdown = get(externalData, 'Dropdown', null);
            pageData.year = '2024';

            dispatch(micYearPageActions.micYearPageLoaded(pageData, store));
            return true;
          }
          if (year === '2023') {
            pageData.externalList = get(
              externalData,
              'winners.records',
              get(externalData, 'TOP 50', null)
            );
            pageData.externalSectors = get(
              externalData,
              'sectors.records',
              get(externalData, 'SECTORS', null)
            );
            dispatch(micYearPageActions.micYearPageLoaded(pageData, store));
            return true;
          }

          if (year === '2022') {
            pageData.externalList = get(
              externalData,
              'list',
              get(externalData, 'Top 50', null)
            );
            pageData.externalSectors = get(
              externalData,
              'sectors',
              get(externalData, 'Sectors', null)
            );
            dispatch(micYearPageActions.micYearPageLoaded(pageData, store));
            return true;
          }

          return false;
        })
        .catch(function handleUserError(err) {
          const status = get(err, 'response.status') || 500;

          if (status === 404) {
            dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          } else {
            dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
            log.error(
              err,
              `Error in tag page actions, message: ${err.message}`
            );
          }
          dispatch(micYearPageActions.micYearPageLoadError(err, store));
        });
    }
    return Promise.all([
      micYearActions(params, store)(dispatch),
      micSectorActions(params, store)(dispatch),
      micYearDescriptionActions(params, store)(dispatch)
    ])
      .then(function handlePostDetailData(data) {
        dispatch(micYearPageActions.micYearPageLoaded(data, store));
        return true;
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;

        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in tag page actions, message: ${err.message}`);
        }
        dispatch(micYearPageActions.micYearPageLoadError(err, store));
      });
  };
}
